import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../components/PaginationTable'; 
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { FaLocationDot } from "react-icons/fa6";


const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];




const ShowIniciativas = () => {
    const [iniciativas, setIniciativas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredReportes, setFilteredReportes] = useState([]);
    const [searchName, setsearchName] = useState('');
    const [error, setError] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde el localStorage
    const itemsPerPage = 4; // Número de elementos por página
    const [avgMontoCancelado, setAvgMontoCancelado] = useState(0);
    const [latestTasa, setLatestTasa] = useState({ tasa: 0, created_at: '' });
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [range, setRange] = useState(30); // Estado para seleccionar el rango de días
    const [statistics, setStatistics] = useState({});
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially


    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('iniciativas', {
        descripcion: '',
        cod:'',   
         

    });
    
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };  
    const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : ""); 

    useEffect(() => {
        setLoading(true);
        getAllIniciativas(currentPage).finally(() => {
            setLoading(false);
        });
    }, []);


    const getAllIniciativas = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/iniciativa-estadisticas`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            
            setIniciativas(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setIniciativas([]);
            setStatistics({});
        }
    };
    
    const deleteIniciativas = async () => {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/iniciativa/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                getAllIniciativas();
                setShowModal(false); // Cierra el modal tras la eliminación exitosa
                toast.success('Iniciativa eliminada con éxito');
            } catch (error) {
                setError('Error deleting data');
                console.error('Error deleting data:', error);
                toast.error('Error al eliminar el Iniciativa');
            }
        
    };
 
  
    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {
            await (getAllIniciativas()); // Espera a que getAllDatos haga la solicitud y actualice los datos
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };
 
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getAllIniciativas(page); // Llama a `getAllDatos` con el nuevo número de página
        
    };

    const totalIniciativas = statistics.totalIniciativas || 0;


    const columns = ["id", "COD","Centro"];

    const renderItem = (iniciativas) => (
        <tr key={iniciativas.id}>
            <td >{iniciativas.id}</td>
        <td >{iniciativas.cod}</td>
        <td >{iniciativas.descripcion}</td>
  
       
        <td >
            <div className="d-flex justify-content-around">
                {userRole === 'admin'  || userRole === 'coordinador' || userRole === 'coorporativo'  ? (

                <Button
                    variant="btn btn-warning" 
                    onClick={() => navigate(`/iniciativas/edit/${iniciativas.id}`)}
                    className="me-2"
                    title='Editar'
                >
                    <i className="bi bi-pencil-fill"></i>
                </Button>
                 ) :null}

                {userRole === 'admin' && (
                <Button
                variant="btn btn-danger"
                onClick={() => handleShowModal(iniciativas.id)}
                className="me-2"
                title='Eliminar'
                >
                <i className="bi bi-trash3-fill"></i>
                </Button>
                )}
            </div>
        </td>
        </tr>
    );

    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
            <div className="col-lg-11 mx-auto d-flex justify-content-center"> 
                <div className="stat-box d-flex justify-content-center align-items-center" style={{ maxWidth: '100%' }}>
                    {/* Total de iniciativas */}
                    <div className="stat-card text-center" style={{ padding: '5px', width: '100%' }}>
                        <div className="stat-icon"><FaLocationDot /></div>
                        <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalIniciativas}</div>
                        <div className="stat-label">Total de Iniciativas</div>
                    </div>
                </div>
            </div>




            <div className="row" style={{ marginTop: '10px' }}>
                {/* Columna para la tabla */}
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h2>Lista de iniciativas</h2>
                        <div className="d-flex align-items-center">
                       
                            <Form.Control
                                name='descripcion'
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.descripcion}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.descripcion)}
                            />
                            <Form.Control
                                name='cod'
                                type="text"
                                placeholder="Buscar por Cod"
                                value={filters.çod}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.çod)}
                            />
                           
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '90px' }} // Ajusta padding y ancho
                                title='Recargar datos'

                                >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                    <FaSync />
                                )}
                            </Button>
                            <Button 
                                    variant="info me-2" 
                                    onClick={getAllIniciativas}
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title='Buscar'
                                >
                                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                </Button>
                            {userRole === 'admin' ||userRole === 'coordinador' || userRole === 'servicio-corp' || userRole === 'corporativo' ? (

                            <Button variant="btn custom" onClick={() => navigate('/iniciativas/create')} className="btn-custom" title='Crear Centro'>
                            <i className="bi bi-pass-fill me-2  "></i> Nuevo
                            </Button>
                            ):null}
                        </div>
                    </div>
                    </div>
                    {/* Tabla paginada */}
                    
                        <PaginationTable
                            data={iniciativas}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  
                        />


                    {/* Modal  de eliminación */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar eliminación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Estás seguro de que deseas eliminar esta Iniciativa?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteIniciativas}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </div>
        
        </div>
        </div>
    );
};

export default ShowIniciativas;
